import React from "react";
import { Link } from "react-router-dom";
import { Phone, Calendar } from "lucide-react";
import { SITE } from "../lib/site";

const MobileBookingBar = () => (
  <div
    className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-forest text-cream border-t border-forest-2 shadow-[0_-8px_24px_-12px_rgba(0,0,0,0.35)]"
    data-testid="mobile-booking-bar"
  >
    <div className="flex">
      <a
        href={SITE.tel}
        className="flex-1 py-4 flex items-center justify-center gap-2 font-semibold text-lg border-r border-cream/20"
        data-testid="mobile-bar-call"
      >
        <Phone className="w-5 h-5" /> Call Sarah
      </a>
      <Link
        to="/contact#booking"
        className="flex-1 py-4 flex items-center justify-center gap-2 font-semibold text-lg bg-daisy text-forest"
        data-testid="mobile-bar-book"
      >
        <Calendar className="w-5 h-5" /> Book a Call
      </Link>
    </div>
  </div>
);

export default MobileBookingBar;
